import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { CardContainer } from '../components/ui/CardContainer';
import { PrimaryButton } from '../components/ui/PrimaryButton';
import { AuthLayout } from '../components/layout/AuthLayout';

export const VerifyEmailPage = () => {
  const { t } = useTranslation();

  return (
    <AuthLayout>
      <CardContainer>
        <div className="text-center">
          <h1 className="text-3xl font-display text-primary mb-4">
            {t('auth.verify_email.title')}
          </h1>
          <p className="text-secondary mb-8">{t('auth.verify_email.description')}</p>

          <div className="space-y-4">
            <Link to="/login">
              <PrimaryButton type="button">{t('auth.verify_email.cta.go_to_login')}</PrimaryButton>
            </Link>
          </div>
        </div>
      </CardContainer>
    </AuthLayout>
  );
};
